import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import { useAuth } from '../../contexts/AuthContext';
import { useReservationsEnAttente } from '../../hooks/useReservationsEnAttente';
import ConnexionBanner from '../shared/ConnexionBanner';

export default function AppLayout() {
  const { proprietaireId } = useAuth();
  const navigate = useNavigate();
  const nouvellesReservations = useReservationsEnAttente(proprietaireId);

  return (
    <div className="app-wrapper">
      {/* Sidebar visible uniquement sur desktop */}
      <div style={{ display: 'none' }} className="sidebar-wrapper">
        <Sidebar badgeCount={nouvellesReservations} />
      </div>
      <style>{`
        @media (min-width: 992px) {
          .sidebar-wrapper { display: block !important; }
          .bottom-nav-wrapper { display: none !important; }
        }
        @keyframes pulse-alarme {
          0%   { opacity: 1; }
          50%  { opacity: 0.7; }
          100% { opacity: 1; }
        }
      `}</style>

      <main className="main-content">
        <ConnexionBanner />
        {nouvellesReservations > 0 && (
          <div
            onClick={() => navigate('/gerant/reservations')}
            style={{
              background: '#E74C3C',
              color: 'white',
              padding: '0.85rem 1rem',
              textAlign: 'center',
              borderRadius: 12,
              marginBottom: '1.25rem',
              fontWeight: 600,
              fontSize: '0.9rem',
              cursor: 'pointer',
              animation: 'pulse-alarme 1s infinite',
            }}
          >
            🔔 {nouvellesReservations} nouvelle{nouvellesReservations > 1 ? 's' : ''} réservation{nouvellesReservations > 1 ? 's' : ''} en attente de confirmation ! Cliquez pour confirmer
          </div>
        )}
        <Outlet />
      </main>

      <div className="bottom-nav-wrapper">
        <BottomNav badgeCount={nouvellesReservations} />
      </div>
    </div>
  );
}
